import { render, staticRenderFns } from "./doceration.vue?vue&type=template&id=304d0994&scoped=true&"
import script from "./doceration.vue?vue&type=script&lang=js&"
export * from "./doceration.vue?vue&type=script&lang=js&"
import style0 from "./doceration.vue?vue&type=style&index=0&id=304d0994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d0994",
  null
  
)

export default component.exports